import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";

type State = {
  IdControleEstoque: number;
  ProdutoPesquisa: number;
}

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setProdutoPesquisa: SetFunction<number>;
};

export const initialFiltersValues: State = {
  IdControleEstoque: 0,
  ProdutoPesquisa: 0
};

export const useControleEstoqueItemFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setProdutoPesquisa: (vfn) => SetFunctionImpl(set, 'ProdutoPesquisa', vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
  })),
}));